import type React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { AnalyticsPageView } from './AnalyticsPageView';
import { useAnalyticsPage } from './useAnalyticsPage';

/**
 * `/analytics` — the tab shell every `/analytics*` URL renders.
 *
 * Same shape as the `/accounting` shells: the tab bar lives here and each tab is
 * a child route, so the selected tab and the address bar are the same fact. No
 * data yet — both tabs are placeholders — so there is no query hook and no
 * `ErrorBoundary`; each arrives with the tab that first needs it, owned by that
 * tab rather than by this shell.
 */
export const AnalyticsPage: React.FC = () => {
    const page = useAnalyticsPage();

    return (
        <div
            className="flex w-full flex-col gap-6"
            {...getNodeTestIdProp('analytics-page')}
        >
            <AnalyticsPageView
                selectedTabId={page.selectedTabId}
                tabs={page.tabs}
            />
        </div>
    );
};
